var render, staticRenderFns
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=e0ef153c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ef153c",
  null
  
)

export default component.exports